import {
    RegionsEnum, ActuatorsFilterPageAmDocument,
    ActuatorsFilterPageApDocument,
    ActuatorsFilterPageEuDocument,
    ActuatorsPageAmDocument, ActuatorsPageAmQuery, ActuatorsPageAmQueryVariables,
    ActuatorsPageApDocument, ActuatorsPageApQuery, ActuatorsPageApQueryVariables,
    ActuatorsPageEuDocument, ActuatorsPageEuQuery, ActuatorsPageEuQueryVariables,
    SolutionActuatorCommonFragmentDoc,
    ActuatorsFilterPagePrimaryDocument,
    ActuatorsFilterPageSecondaryAmDocument,
    ActuatorsFilterPageSecondaryApDocument,
    ActuatorsFilterPageSecondaryEuDocument,
    ActuatorsFilterPageDocument,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getValvesPageConfig } from 'src/modules/valves/ValvesPageMapping.ts';
import { generateItemsConfig } from 'src/utils/generateOrderItems.ts';

export type ActuatorsPageData = Omit<ActuatorsPageEuQuery | ActuatorsPageApQuery | ActuatorsPageAmQuery, '__typename'>;
export type ActuatorsPageVariables = Omit<
ActuatorsPageEuQueryVariables | ActuatorsPageApQueryVariables | ActuatorsPageAmQueryVariables, '__typename'
>;

export type ActuatorsPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    filterConfig: FilterConfig;
    additionalFilterConfig: FilterConfig;
    orderItemsConfig: FilterConfig;
    queryPrimary: DocumentNode;
    genericFilterQuery: DocumentNode;
    filterConfigPrimary: FilterConfig;
    filterConfigSecondary: FilterConfig;
}

export const getActuatorsPageConfig = (region: RegionsEnum): ActuatorsPageConfig | null => {
    const valvesPageConfig = getValvesPageConfig(region);
    if (valvesPageConfig === null) {
        throw new Error('No Valves Page Config');
    }

    const filterConfigPrimary = generateFiltersConfig(ActuatorsFilterPagePrimaryDocument, 'vssActuatorsValues');
    const queryPrimary = removeDuplicateFragments(ActuatorsFilterPagePrimaryDocument);
    const genericFilterQuery = removeDuplicateFragments(ActuatorsFilterPageDocument);

    const { mainFilterConfig, filterConfig: additionalFilterConfig } = valvesPageConfig;
    if (region === RegionsEnum.Eu) {
        const filterConfigSecondary = generateFiltersConfig(
            ActuatorsFilterPageSecondaryEuDocument,
            'vssActuatorsValues',
        );

        return {
            query: removeDuplicateFragments(ActuatorsPageEuDocument),
            filterConfig: generateFiltersConfig(ActuatorsFilterPageEuDocument, 'vssActuatorsValues'),
            orderItemsConfig: generateItemsConfig(SolutionActuatorCommonFragmentDoc),
            mainFilterConfig,
            additionalFilterConfig,
            queryPrimary,
            genericFilterQuery,
            filterConfigPrimary,
            filterConfigSecondary,
        };
    }
    if (region === RegionsEnum.Ap) {
        const filterConfigSecondary = generateFiltersConfig(
            ActuatorsFilterPageSecondaryApDocument,
            'vssActuatorsValues',
        );

        return {
            query: removeDuplicateFragments(ActuatorsPageApDocument),
            filterConfig: generateFiltersConfig(ActuatorsFilterPageApDocument, 'vssActuatorsValues'),
            orderItemsConfig: generateItemsConfig(SolutionActuatorCommonFragmentDoc),
            mainFilterConfig,
            additionalFilterConfig,
            queryPrimary,
            genericFilterQuery,
            filterConfigPrimary,
            filterConfigSecondary,
        };
    }
    if (region === RegionsEnum.Am) {
        const filterConfigSecondary = generateFiltersConfig(
            ActuatorsFilterPageSecondaryAmDocument,
            'vssActuatorsValues',
        );

        return {
            query: removeDuplicateFragments(ActuatorsPageAmDocument),
            filterConfig: generateFiltersConfig(ActuatorsFilterPageAmDocument, 'vssActuatorsValues'),
            orderItemsConfig: generateItemsConfig(SolutionActuatorCommonFragmentDoc),
            mainFilterConfig,
            additionalFilterConfig,
            queryPrimary,
            genericFilterQuery,
            filterConfigPrimary,
            filterConfigSecondary,
        };
    }
    return null;
};
